import * as React from "react";
import styled from "styled-components";

export function DocsTitle() {
  return (
    <TitleContainer>
      <SubTitleWrapper>
        <DocIcon
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/fddd5ebf294fc131610e05bf0dae2f7e6a54635b30932dee55b18a459dd55a9f?placeholderIfAbsent=true&apiKey=af3b926ef0c2405e9a702a855cd6e35e"
          alt="Docs icon"
        />
        <SubTitleText>Documents</SubTitleText>
      </SubTitleWrapper>
      <MainTitle>Download</MainTitle>
    </TitleContainer>
  );
}

const TitleContainer = styled.div`
  align-self: stretch;
  padding-left: 5rem;
  display: flex;
  min-width: 240px;
  flex-direction: column;
  white-space: nowrap;
  justify-content: start;
  width: 585px;
  margin: auto 0;

  @media (max-width: 991px) {
    max-width: 100%;
    white-space: initial;
  }
`;

const SubTitleWrapper = styled.div`
  align-self: start;
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  color: var(--Secondary, #232323);
  text-transform: uppercase;
  letter-spacing: 1.92px;
  line-height: 1;
  justify-content: start;

  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const DocIcon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 20px;
  align-self: stretch;
  margin: auto 0;
`;

const SubTitleText = styled.div`
  align-self: stretch;
  margin: auto 0;
`;

const MainTitle = styled.h1`
  color: var(--Primary, #222);
  font-size: 48px;
  line-height: 1.4;
  margin-top: 11px;

  @media (max-width: 991px) {
    max-width: 30%;
    font-size: 40px;
  }
`;
